import { type JSX, useState } from "react";
import type { ChallengeInfo } from "@/sales-tools/challenges/api/getChallenge";
import { AnnouncementStartCover } from "./AnnouncementStartCover";
import { AnnouncementStartDetails } from "./AnnouncementStartDetails";

export function AnnouncementStartGeneric({
    challenge,
    onContinueClick,
}: {
    challenge: ChallengeInfo;
    onContinueClick: () => void;
}): JSX.Element {
    const [isShowingDetails, setIsShowingDetails] = useState(false);

    const handleViewDetailsClick = () => {
        setIsShowingDetails(true);
    };

    return isShowingDetails ? (
        <AnnouncementStartDetails challenge={challenge} onDismiss={onContinueClick} />
    ) : (
        <AnnouncementStartCover challenge={challenge} onViewDetailsClick={handleViewDetailsClick} />
    );
}
